import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DataService {

  private apiUrl = environment.apiUrl;


  constructor(private http: HttpClient) { }

  getScopes(): Observable<any[]> {
    return this.http.get<any[]>('/api/Config/GetScopes');
  }

  getFields(): Observable<any[]> {
    return this.http.get<any[]>('/api/Config/GetScopeFields');
  }

  getDropDownOptions(field: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}DrakeData/GetDropDownValues/` + field);
  }

  getScopeData(scope: string, viewCode: string): Observable<any> {
    return this.http.post<any[]>(`${this.apiUrl}DrakeData/GetScopeData/${scope}/${"READ"}`, {ViewCode: viewCode});
  }

  getScope(scope: string): Observable<any> {
    return this.http.post<any[]>(`${this.apiUrl}DrakeData/GetScopeData/${scope}`, {});
  }

  getChartsData(id: string): Observable<any> {
    return this.http.post<any[]>(`${this.apiUrl}DrakeData/GetChartsData/${id}`, {});
  }

  
}
